import { useStore } from '../stores/store'

/**
 * Returns the enabled state of a feature flag by key.
 * Defaults to false when the flag is absent or not yet loaded.
 */
export const useFeatureFlag = (key: string): boolean => {
  const { commonStore } = useStore()
  return commonStore.featureFlags[key] ?? false
}
